/**
 * Monitoramento temporário: pessoas com interesse em contratar prestadores.
 *
 * Desligar o recurso:
 * - defina VUE_APP_CONTRACTOR_INTEREST_LOG=0 no .env, ou
 * - altere ENABLED abaixo para false, ou
 * - remova/comente as chamadas em ProviderSearch.vue e RegisterProject.vue
 *
 * Backend: getlanceapi — POST {baseURL}/contractor-interest
 * Migration: database/migrations/1780000000008_create_contractor_interest_leads_schema.js
 * Headers: Authorization Bearer (opcional). (x-api-key pode ser enviado, mas não é obrigatório)
 * Body JSON: { type: 'presential' | 'remote', address?: string, email?: string }
 * O servidor deve preencher user_id a partir do JWT quando houver token.
 */

const ENABLED =
  typeof process.env.VUE_APP_CONTRACTOR_INTEREST_LOG === 'string'
    ? process.env.VUE_APP_CONTRACTOR_INTEREST_LOG === '1' ||
      process.env.VUE_APP_CONTRACTOR_INTEREST_LOG === 'true'
    : true

function resolveEmail (explicit) {
  if (explicit && String(explicit).trim()) return String(explicit).trim()
  try {
    const raw = localStorage.getItem('userData')
    if (!raw) return null
    const { user } = JSON.parse(raw)
    return user?.email ? String(user.email).trim() : null
  } catch {
    return null
  }
}

function resolveToken () {
  try {
    const raw = localStorage.getItem('userData')
    if (!raw) return null
    const { token } = JSON.parse(raw)
    return token ? String(token) : null
  } catch {
    return null
  }
}

function isBlockedTestEmail (email) {
  return String(email || '').trim().toLowerCase() === 'daniel.silvalima89@gmail.com'
}

/**
 * @param {{ type: 'presential' | 'remote', address?: string, email?: string }} payload
 */
export function logContractorInterest (payload) {
  if (!ENABLED) return Promise.resolve()

  const base = (process.env.VUE_APP_URL_API || '').replace(/\/+$/, '')
  if (!base) return Promise.resolve()

  const email = resolveEmail(payload?.email)
  if (isBlockedTestEmail(email)) return Promise.resolve()

  const body = { type: payload.type }
  if (payload.address != null && String(payload.address).trim()) {
    body.address = String(payload.address).trim()
  }
  if (email) body.email = email

  const apiKey =
    import.meta?.env?.VUE_APP_API_KEY ||
    process.env.VUE_APP_API_KEY ||
    ''

  const headers = {
    'Content-Type': 'application/json',
  }
  if (apiKey) headers['x-api-key'] = apiKey
  const token = resolveToken()
  if (token) headers.Authorization = `Bearer ${token}`

  return fetch(`${base}/contractor-interest`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  }).catch(() => {})
}
